import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';

export const scaleFadeInAnimation = (duration: number): AnimationTriggerMetadata => {
  return trigger('scaleFadeIn', [
    transition(':enter', [
      style({
        transform: 'scale(0.8)',
        opacity: 0,
      }),
      animate(
        `${duration}ms cubic-bezier(0.35, 0, 0.25, 1)`,
        style({
          transform: 'scale(1)',
          opacity: 1,
        })
      ),
    ]),
    transition(':leave', [style({ opacity: 1 }), animate(`${duration}ms ease-in`, style({ opacity: 0 }))]),
  ]);
};

export const scaleFadeIn400ms = scaleFadeInAnimation(400);
